import React from 'react';
import { useTranslation } from 'react-i18next';

import ClearIcon from '@mui/icons-material/Clear';
import SendIcon from '@mui/icons-material/Send';
import { styled, useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Flex from 'ui/Flex/Flex';
import { StyButton } from './ui/StyButtonUserForm';

const StyPaper = styled(Paper)(({ theme }) => ({
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
}));

const ACTIVATION_SECTION_TRANSLATION_PATH =
    'adminSpace.createUser.modalStepper.activationSection.emailScheduling';

type Props = {
    setShouldSendActivationEmail: (arg: boolean) => void;
    shouldSendActivationEmail: boolean;
    translationPath?: string;
};

const UserFormActivationSection = ({
    setShouldSendActivationEmail,
    shouldSendActivationEmail,
    translationPath,
}: Props): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    const trPath = translationPath || ACTIVATION_SECTION_TRANSLATION_PATH;

    return (
        <StyPaper>
            <Typography
                variant="body1Bold"
                sx={{ marginBottom: theme.spacing(3) }}
            >
                {t(`${trPath}.title`)}
            </Typography>
            <Flex flex={1} alignItems="center" gap={2}>
                <StyButton
                    data-testid="e2e-send-activation-email-now-button"
                    variant="outlined"
                    buttonStyle="success"
                    onClick={() => {
                        setShouldSendActivationEmail(true);
                    }}
                    selected={shouldSendActivationEmail}
                    startIcon={<SendIcon color="success" />}
                >
                    {t(`${trPath}.sendNowOption`)}
                </StyButton>
                <StyButton
                    data-testid="e2e-send-activation-email-later-button"
                    variant="outlined"
                    buttonStyle="error"
                    onClick={() => {
                        setShouldSendActivationEmail(false);
                    }}
                    selected={!shouldSendActivationEmail}
                    startIcon={<ClearIcon color="error" />}
                >
                    {t(`${trPath}.sendLaterOption`)}
                </StyButton>
            </Flex>
        </StyPaper>
    );
};

export default UserFormActivationSection;
